// ConfigRefreshScheduler.jsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import getConfigData from '../selector/getConfigData.js';

import { refreshGrowthBookConfig } from '../action/configActions.js';

import {
  GrowthBookInitStatus,
  REFRESH_INTERVAL_SECONDS,
} from '../resource/configConstants.js';
import { remoteConfig as remoteConfigDebug } from '../resource/debug.js';

const log = remoteConfigDebug.extend('log:component/ConfigRefreshScheduler');

export const ConfigRefreshScheduler = () => {
  const dispatch = useDispatch();
  const growthBookInitStatus = useSelector(state =>
    getConfigData(state, ['status'], 'initStatus')
  );

  useEffect(() => {
    log('execute refresh useEffect', { growthBookInitStatus });
    let timerId;
    if (growthBookInitStatus === GrowthBookInitStatus.SUCCESS) {
      timerId = setInterval(() => {
        log('refresh growthbook config', {
          growthBookInitStatus,
        });
        dispatch(refreshGrowthBookConfig());
      }, REFRESH_INTERVAL_SECONDS * 1000);
    }

    return () => {
      clearInterval(timerId);
    };
  }, [dispatch, growthBookInitStatus]);

  return null;
};

export default ConfigRefreshScheduler;
